import {Component, Input} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {DateHelper, FormBaseComponent, ValidatorService} from '@utils-lib';
import {Person, ReligionsschluesselEnumLabels} from '@nachdigal';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
  selector: 'common-ui-person',
  templateUrl: './person.component.html'
})
export class PersonComponent extends FormBaseComponent<Person> {

  @Input()
  public affectNavigationInfo = false;
  public religionsschluesselEnum = ReligionsschluesselEnumLabels;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              private readonly translateService: TranslateService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      geburtsname: [this.data.geburtsname, [
        this.validatorService.minLength(1),
        this.validatorService.maxLength(72)
      ]],
      geburtsdatum: [
        this.data.geburtsdatum, [
          this.validatorService.required(),
          this.validatorService.date(),
          this.validatorService.conditionTrue(() => DateHelper.isNotInFuture(this.data.geburtsdatum),
            this.translateService.instant('COMMON_UI.VALIDATION.DATE_IS_IN_FUTURE'))
        ]
      ],
      religionsschluessel: [
        this.data.religionsschluessel, [
          this.validatorService.required()
        ]
      ],
      beruf: [
        this.data.beruf, [
          this.validatorService.minLength(1),
          this.validatorService.maxLength(51)]
      ]
    });
  }
}
